import React from 'react'

const getStatusConfig = (status) => {
  const numStatus = status !== null && status !== undefined ? Number(status) : null

  if (numStatus === 0 || status === '0' || status === 'Dalam Proses' || status === 'dalam proses') {
    return {
      label: 'Dalam Proses',
      bg: '#FFFBEB',
      color: '#B45309',
      borderColor: '#FDE68A',
      dotColor: '#F59E0B'
    }
  }

  if (numStatus === 1 || status === '1' || status === 'Selesai' || status === 'selesai') {
    return {
      label: 'Selesai',
      bg: '#ECFDF5',
      color: '#047857',
      borderColor: '#A7F3D0',
      dotColor: '#10B981'
    }
  }

  if (numStatus === 2 || status === '2' || status === 'Ditolak' || status === 'ditolak') {
    return {
      label: 'Ditolak',
      bg: '#FEF2F2',
      color: '#B91C1C',
      borderColor: '#FECACA',
      dotColor: '#EF4444'
    }
  }

  return {
    label: status !== null && status !== undefined ? String(status) : 'Dalam Proses',
    bg: '#F3F4F6',
    color: '#4B5563',
    borderColor: '#E5E7EB',
    dotColor: '#9CA3AF'
  }
}

const StatusBadge = ({ status, style = {} }) => {
  const config = getStatusConfig(status)

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '3px 10px',
        borderRadius: '20px',
        fontSize: '0.78em',
        fontWeight: '600',
        lineHeight: 1.2,
        backgroundColor: config.bg,
        color: config.color,
        border: `1px solid ${config.borderColor}`,
        whiteSpace: 'nowrap',
        ...style
      }}
    >
      <span
        style={{
          width: '6px',
          height: '6px',
          borderRadius: '50%',
          backgroundColor: config.dotColor,
          display: 'inline-block'
        }}
      />
      {config.label}
    </span>
  )
}

export default StatusBadge
